import styled, { css } from 'styled-components';

import InputHints from 'react-input-hints';
import { COLORS } from 'styles/constants';

interface SuggestionProps {
  active: boolean;
}

export const Container = styled.div`
  width: 70%;

  position: relative;
  display: inline-block;

  @media only screen and (max-width: 900px) {
    width: 90%;
  }
`;

export const SearchContainer = styled.div`
  padding: 20px;

  border-radius: 5px;
  background: #fff;

  display: flex;
  align-items: center;

  &:hover {
    border: solid 2px ${COLORS.primary} outset;
  }
`;

export const SearchInput = styled(InputHints)`
  width: 100%;
  height: 180%;

  font-size: 18px !important;

  border: none;
`;

export const CloseSearchButton = styled.button`
  border: none;
  background: none;

  display: flex;
  align-items: center;

  svg {
    color: ${COLORS.primary} !important;
    width: 30px !important;
  }

  &:hover {
    svg {
      width: 40px;
    }
  }
`;

export const Suggestions = styled.ul`
  position: absolute;
  width: 100%;
  max-height: 190px;
  margin-top: -10px;
  overflow-y: hidden;

  border-radius: 0 0 5px 5px;

  z-index: 99;

  top: 100%;
  left: 0;
  right: 0;
`;

export const Suggestion = styled.button<SuggestionProps>`
  width: 100%;
  padding: 12px 15px;
  text-align: left;

  border: none;
  transition: background 0.1s;

  &:not(:last-of-type) {
    border-bottom: 1px solid #999;
  }

  &:hover {
    background-color: ${COLORS.primary};
    color: ${COLORS.white};
    cursor: pointer;
  }

  @media only screen and (min-width: 1024px) {
    ${(props) =>
      props.active &&
      css`
        background-color: ${COLORS.secondary};
        color: ${COLORS.white};
        cursor: pointer;
      `};
  }
`;

export const NoSuggestions = styled.div`
  color: #999;
  padding: 0.5rem;
`;
